// src/components/Layout/MovimientoList.js
import React, { useEffect, useState, useContext } from 'react';
import { getMovimientos, deleteMovimiento } from '../../services/api';
import { AuthContext } from '../../contexts/AuthContext';
import {
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Box,
  CircularProgress,
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

const MovimientoList = () => {
  const [movimientos, setMovimientos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    const fetchMovimientos = async () => {
      try {
        const data = await getMovimientos();
        if (data.success) {
          setMovimientos(data.data);
        } else {
          setError('Error al obtener movimientos');
        }
      } catch (err) {
        setError(err.error || 'Error al obtener movimientos');
      } finally {
        setLoading(false);
      }
    };

    fetchMovimientos();
  }, []);

  const handleEdit = (id) => {
    navigate(`/movimientos/edit/${id}`);
  };

  const handleDeleteClick = (id) => {
    setSelectedId(id);
    setOpenDialog(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      const data = await deleteMovimiento(selectedId);
      if (data.success) {
        setMovimientos(movimientos.filter((movimiento) => movimiento.id !== selectedId));
      } else {
        setError('Error al eliminar movimiento');
      }
    } catch (err) {
      setError(err.error || 'Error al eliminar movimiento');
    } finally {
      setOpenDialog(false);
      setSelectedId(null);
    }
  };

  const handleDeleteCancel = () => {
    setOpenDialog(false);
    setSelectedId(null);
  };

  if (loading) return <CircularProgress />;

  if (error) return <Alert severity="error">{error}</Alert>;

  return (
    <Container>
      <Box display="flex" justifyContent="space-between" alignItems="center" mt={4} mb={2}>
        <Typography variant="h4">Movimientos</Typography>
        {user.permisos && user.permisos.crearProductos && (
          <Button variant="contained" color="primary" onClick={() => navigate('/movimientos/new')}>
            Crear Movimiento
          </Button>
        )}
      </Box>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Tipo</TableCell>
            <TableCell>Fecha</TableCell>
            <TableCell>Estado</TableCell>
            <TableCell>Bodega</TableCell>
            <TableCell>Usuario</TableCell>
            <TableCell>Observación</TableCell>
            <TableCell>Proveedor/Cliente</TableCell>
            <TableCell>Acciones</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {movimientos.map((movimiento) => (
            <TableRow key={movimiento.id}>
              <TableCell>{movimiento.id}</TableCell>
              <TableCell>{movimiento.tipo}</TableCell>
              <TableCell>{new Date(movimiento.fecha).toLocaleString()}</TableCell>
              <TableCell>{movimiento.estado}</TableCell>
              <TableCell>{movimiento.idBodega}</TableCell>
              <TableCell>{movimiento.usuario}</TableCell>
              <TableCell>{movimiento.observacion}</TableCell>
              <TableCell>{movimiento.proveedorCliente}</TableCell>
              <TableCell>
                <Button variant="outlined" color="primary" onClick={() => handleEdit(movimiento.id)}>
                  Editar
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => handleDeleteClick(movimiento.id)}
                  style={{ marginLeft: '8px' }}
                >
                  Eliminar
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* Diálogo de Confirmación para Eliminar */}
      <Dialog
        open={openDialog}
        onClose={handleDeleteCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Confirmar Eliminación</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            ¿Estás seguro de que deseas eliminar este movimiento? Esta acción no se puede deshacer.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleDeleteConfirm} color="secondary" autoFocus>
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default MovimientoList;
